import { useGetAiStatusQuery } from '@/store/api/aiApi';

/**
 * Ob eine KI-Funktion für diese Person in diesem Mandanten gerade geht —
 * und wenn nicht, warum. Der ai-service beurteilt Schalter, Recht,
 * Datenklasse und Anbieter zusammen; die Oberfläche fragt nur nach.
 *
 * Wer das Recht nicht hat oder dessen Mandant die Funktion nicht
 * freigeschaltet hat, sieht den Knopf nicht — dasselbe Muster wie bei jedem
 * anderen Recht (Konzept 3.7). Antwortet der Dienst nicht, gilt: nicht
 * verfügbar. Ein Knopf, der ins Leere führt, ist schlimmer als keiner.
 */
export function useKiFunktion(key: string): { verfuegbar: boolean; grund: string | null } {
  const { data } = useGetAiStatusQuery(undefined, { refetchOnMountOrArgChange: 60 });
  const funktion = data?.functions.find((f) => f.key === key);
  if (!funktion) return { verfuegbar: false, grund: null };
  return { verfuegbar: funktion.available, grund: funktion.reason };
}
